//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      isDisable:false,
      consultation: [
      ],
      inquiry: {},
      orderId: ""
    };
  },
  created() {
    this.$isLogin(window.location.search.substr(1), this.query);
    document.title = '填写问诊单';
    this.orderId = this.$route.query.orderId;
//    this.query1();
  },
  methods: {
    updateTop(){
      window.scroll(0,0);
    },
    query1() {
      var _this = this;
      var data = {
        orderID: this.orderId,
        isInterrogationsingle: 1,
        ischecked: 1
      };
      this.$doRequest("/api/Inquiry/orderDetails", data, res => {
        if(res.reorderinquiryquestion.length>0){
          _this.$toastMsg("请勿重复填写问诊单");
          _this.$router.back(-1);
        }
      });
    },
    query() {
      var _this = this;
      var data={
        parameters: _this.$route.query.templaterId,//模板id
        parametersone:_this.$route.query.templaterId  //模板id
      }
      this.$doRequest("/api/Inquiry/getConsultationForm", data, res => {   //data变成null
        if (res.result == 0) {
          for (var i = 0; i < res.parameters.length; i++) {
            res.parameters[i].ischecked = [];
            _this.consultation.push(res.parameters[i]);
          }
        }
      });
    },
    ab(a) {
      var answer = [];
      var answers = {};
      var _this = this;
      for (var j = 0; j < a.length; j++) {
        answers = {
          orderid: _this.$route.query.orderId,
          qustionid: a[j].questionid,
          anwser: a[j].anwser,
          ischecked: null,
          id: a[j].id
        };
        answer.push(answers);
      }
      return answer;
    },
    sendDoctor() {
      var consultation = this.consultation;
      var reorderinquiryquestion = [];
      var question = {};
      var _this = this;
      for (var i = 0; i < consultation.length; i++) {
        if(consultation[i].singleselection!=3){
          if(typeof consultation[i].ischecked == 'string'){
            var c = consultation[i].ischecked;
            consultation[i].ischecked = [];
            consultation[i].ischecked.push(c);
          }
          if (consultation[i].ischecked.length == 0&&consultation[i].isrequired==1) {
            this.$toastMsg("请补填第" + (i + 1) + "题");
            return false;
          } else {
            question = {
              ordereid: _this.$route.query.orderId,
              questionname: consultation[i].questionname,
              singleselection: consultation[i].singleselection,
              isrequired: consultation[i].isrequired,
              answerId: consultation[i].ischecked
            };
            var a = consultation[i].orderinquiryoptions;
            question.orderinquiryoptions = _this.ab(a);
            reorderinquiryquestion.push(question);
          }
        }else{
          if((consultation[i].answerName == ''||consultation[i].answerName == null)&&consultation[i].isrequired==1){
            this.$toastMsg("请补填第" + (i + 1) + "题");
            return false;
          }else{
            question = {
              ordereid: _this.$route.query.orderId,
              questionname: consultation[i].questionname,
              singleselection: consultation[i].singleselection,
              isrequired: consultation[i].isrequired,
              answerId: consultation[i].ischecked,
              answerName: consultation[i].answerName
            };
            reorderinquiryquestion.push(question);
          }

        }

      }
      _this.isDisable=true;
      setTimeout(()=>{
        _this.isDisable=false   //点击一次时隔两秒后才能再次点击
      },2000)
      var data = {
        orderid: this.$route.query.orderId,
        reorderinquiryquestion: reorderinquiryquestion
      };
      this.$doRequest("/api/Inquiry/inquirySubmission", data, res => {
        _this.$toastMsg("提交成功");
        var ext = {
          'businessType': 'profileFinish',
          'orderid': _this.$route.query.orderId
        };
        _this.$sendPrivateText(_this,_this.$store.state.AllOfValue.ImDoctorInfo.doctorId,'我已上传问诊单',function(msg){
          _this.$router.go(-1);
          var data = {
            fromid: _this.$store.state.userInfo.id,
            toid: _this.messages.doctorId,
            msgtype: '3',
            val: '患者已上传问诊单',
            fromType: '2',
            fromName: _this.$store.state.userInfo.patientnickname,
            orderid: _this.$route.query.orderId
          }
          _this.$doRequest('/api/ImUtil/signIm',data,function(res){
          })
        },ext);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/upload/one/one.vue